import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import DownloadIcon from '@mui/icons-material/Download';
import { IProps } from './IProps';
import useDictionary from '@ui/hooks/useDictionary';

const Component: React.FC<IProps> = ({
    headers,
    rows,
    imei,
    name,
    onDownloadClick,
    onClose,
}: IProps) => {
    const getWord = useDictionary();
    const title = getWord('infoAboutDevice');

    return (
        <>
            <Box className="device-info__wrap">
                <Box className="device-info">
                    <IconButton className="close-btn" onClick={onClose}>
                        <CloseIcon className="close-btn__ico" />
                    </IconButton>
                    <Typography className="device-info__title" variant="h6">
                        {title}
                    </Typography>
                    <Typography
                        className="device-info__title-text"
                        variant="body1"
                    >
                        {`${name} [${imei}]`}
                    </Typography>
                    <Box className="device-info__table-wrap">
                        <Table className="device-info__table" size="small">
                            <TableHead className="device-info__table-header">
                                <TableRow className="device-info__table-row">
                                    {headers.map((header) => (
                                        <TableCell className="device-info__table-cell">
                                            {getWord(header)}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody className="device-info__table-body">
                                {rows.map((row) => (
                                    <TableRow className="device-info__table-row">
                                        {headers.map((header) => (
                                            <TableCell className="device-info__table-cell">
                                                {
                                                    row[
                                                        header as keyof typeof row
                                                    ]
                                                }
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Box>
                    <Box className="device-info__btn-bar">
                        <Button
                            className="device-info__btn"
                            variant="contained"
                            onClick={onDownloadClick}
                        >
                            <DownloadIcon className="device-info__btn-ico" />
                            {getWord('download')}
                        </Button>
                        <Button
                            className="device-info__btn"
                            variant="contained"
                            color="error"
                            onClick={onClose}
                        >
                            {getWord('close')}
                        </Button>
                    </Box>
                </Box>
            </Box>
        </>
    );
};

const DeviceInfoComponent = React.memo(Component);

export default DeviceInfoComponent;
